import {Permissions} from "@/js/Permissions";

const LibraClientRoutes = [
  {
    path: '/settings',
    name: 'settings_index',
    component: () => import("@/views/settings/IndexView.vue"),
    meta: {permissions: [Permissions.LIBRA]},
  },
]

export default LibraClientRoutes;
